import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@/components/ui/popover'
import { cn } from '@/lib/utils'
import { HexColorPicker } from 'react-colorful'

interface ColorPickerProps {
	value: string
	onChange: (value: string) => void
	className?: string
}

export function ColorPicker({ value, onChange, className }: ColorPickerProps) {
	return (
		<Popover>
			<PopoverTrigger asChild>
				<button
					className={cn(
						'h-8 w-full rounded-md border border-input bg-background px-3',
						className
					)}>
					<div className="flex items-center gap-2">
						<div
							className="h-4 w-4 rounded-full border"
							style={{ backgroundColor: value }}
						/>
						<span className="text-sm">{value}</span>
					</div>
				</button>
			</PopoverTrigger>
			<PopoverContent className="w-auto p-0" align="start">
				<HexColorPicker color={value} onChange={onChange} />
			</PopoverContent>
		</Popover>
	)
}
